import React from 'react';
import { Globe, Code2, Rocket, ShieldCheck, Zap, Database } from 'lucide-react';
import './SaaSDevelopment.css';

const WebApplications = () => {
  return (
    <div className="saas-page">
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-copy">
            <span className="eyebrow">Enterprise Web Solutions</span>
            <h1>High-Performance Web Applications for Modern Business</h1>
            <p>
              Scalable, secure, and intuitive web applications built with cutting-edge 
              technologies to drive your business forward.
            </p>
            <div className="hero-actions">
              <a className="button primary" href="#contact">Build Your App</a>
              <a className="button secondary" href="#capabilities">Our Tech Stack</a>
            </div>
          </div>
          <div className="hero-panel">
            <div className="panel-card panel-gradient">
              <Globe className="icon" />
              <h3>Cloud-Native</h3>
              <p>Applications designed to leverage the full power of modern cloud infrastructure.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="capabilities" className="section">
        <div className="section-heading">
          <span className="eyebrow">Capabilities</span>
          <h2>Robust solutions for a competitive edge.</h2>
          <p>We combine modern frameworks with deep architectural expertise to build web apps that scale effortlessly.</p>
        </div>

        <div className="capabilities-grid">
          <div className="capability-card">
            <div className="cap-icon"><Code2 size={24} /></div>
            <h3>React & Next.js</h3>
            <p>High-performance frontends with server-side rendering for optimal speed and SEO.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Database size={24} /></div>
            <h3>Scalable Backends</h3>
            <p>Robust server architectures using Node.js, Python, or Go to handle massive user loads.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><ShieldCheck size={24} /></div>
            <h3>Security First</h3>
            <p>Comprehensive security integration from authentication to data encryption at rest.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Zap size={24} /></div>
            <h3>PWA Excellence</h3>
            <p>Progressive Web Apps that provide app-like experiences directly in the browser.</p>
          </div>
        </div>
      </section>

      <section className="section bg-glass">
        <div className="solutions-container">
          <div className="solution-row">
            <div className="solution-copy">
              <h3>Real-time Data Processing</h3>
              <p>
                Whether it is live dashboards or collaborative tools, we build systems 
                that synchronize data instantly across all user sessions.
              </p>
              <ul className="feature-list">
                <li><Zap size={18} /> WebSocket Integration</li>
                <li><Zap size={18} /> Real-time Analytics</li>
                <li><Zap size={18} /> Low-latency Processing</li>
              </ul>
            </div>
            <div className="solution-media">
              <div className="panel-card panel-glow">
                <Rocket className="icon" size={48} />
                <p>Speed focused architecture delivering sub-second load times for complex dashboards.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="metrics-grid">
        <div className="metric-item">
          <strong>99.9%</strong>
          <span>Availability</span>
        </div>
        <div className="metric-item">
          <strong>&lt;200ms</strong>
          <span>API Response</span>
        </div>
        <div className="metric-item">
          <strong>100%</strong>
          <span>Mobile Responsive</span>
        </div>
        <div className="metric-item">
          <strong>24/7</strong>
          <span>Monitoring</span>
        </div>
      </div>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Ready to launch your web application?</h2>
          <p>Let us help you build the digital future of your company.</p>
          <a className="button primary" href="#contact">Get Started</a>
        </div>
      </section>
    </div>
  );
};

export default WebApplications;
